export type Person = {
  name: string;
  email: string;
  managerEmail: string;
  photoUrl: string | undefined;
  title: string;
  location: string;
  department: string;
};
